var $872ff7d4ea32e9fa$exports = {};
let $872ff7d4ea32e9fa$var$all_data;
const $872ff7d4ea32e9fa$var$calendarElement = document.querySelector('#event-wrapper');
const $872ff7d4ea32e9fa$var$nowBarElement = document.querySelector('#calendar-today #now');
const $872ff7d4ea32e9fa$var$preferred_event_min_width = 200;
const $872ff7d4ea32e9fa$var$min_visible_width = 50;
const $872ff7d4ea32e9fa$var$min_event_height = 47.5;
const $872ff7d4ea32e9fa$var$padding = 5;
const $872ff7d4ea32e9fa$var$pixels_per_minute = 1.5;
let $872ff7d4ea32e9fa$var$startDate;
let $872ff7d4ea32e9fa$var$startTime;
let $872ff7d4ea32e9fa$var$endDate;
let $872ff7d4ea32e9fa$var$endTime;
let $872ff7d4ea32e9fa$var$events;
let $872ff7d4ea32e9fa$var$showNowBar = true;
let $872ff7d4ea32e9fa$var$backgroundColor = 'rgb(255, 255, 255)';
let $872ff7d4ea32e9fa$var$textColor = 'black';
/// Place period boxes for a list of periods.
function $872ff7d4ea32e9fa$var$place_boxes(data_unprocessed, date = current_date(), force = false, today = true) {
    $872ff7d4ea32e9fa$var$showNowBar = today;
    $872ff7d4ea32e9fa$var$calendarElement.innerHTML = '';
    if (data_unprocessed && (!$872ff7d4ea32e9fa$var$events || force)) {
        $872ff7d4ea32e9fa$var$calendarElement.style.height = 'auto';
        if (!data_unprocessed.periods[0]) {
            $872ff7d4ea32e9fa$var$updateNowBar();
            return;
        }
        const data = replace_period(data_unprocessed.periods.filter((p)=>p.kind !== 'Passing')).filter(Boolean);
        $872ff7d4ea32e9fa$var$startDate = date_from_api(data[0].start, date);
        $872ff7d4ea32e9fa$var$startTime = $872ff7d4ea32e9fa$var$startDate.getTime() / 1000;
        $872ff7d4ea32e9fa$var$endDate = date_from_api(data[data.length - 1].end, date);
        $872ff7d4ea32e9fa$var$endTime = $872ff7d4ea32e9fa$var$endDate.getTime() / 1000;
        $872ff7d4ea32e9fa$var$updateNowBar();
        const sInDay = $872ff7d4ea32e9fa$var$endTime - $872ff7d4ea32e9fa$var$startTime;
        let containerHeight = sInDay / 60 * $872ff7d4ea32e9fa$var$pixels_per_minute;
        const lastColHeight = {};
        // Resolve rows so everything is mutually non-intersecting.
        $872ff7d4ea32e9fa$var$events = [];
        for (const [i, period] of data.sort((a, b)=>date_from_api(a.start, date) - date_from_api(b.start, date)).entries()){
            // Set up variables
            const start = date_from_api(period.start, date).getTime() / 1000;
            const end = date_from_api(period.end, date).getTime() / 1000;
            const duration = end - start;
            let heightChange = 0;
            const startPos = (start - $872ff7d4ea32e9fa$var$startTime) / 60 * $872ff7d4ea32e9fa$var$pixels_per_minute;
            let height = duration / 60 * $872ff7d4ea32e9fa$var$pixels_per_minute;
            const endPos = startPos + height;
            if (height < $872ff7d4ea32e9fa$var$min_event_height) {
                heightChange = $872ff7d4ea32e9fa$var$min_event_height - height;
                height = $872ff7d4ea32e9fa$var$min_event_height;
            }
            let col = 0;
            while($872ff7d4ea32e9fa$var$events.filter((event)=>event.col === col).some((event)=>startPos < event.endPos || endPos < event.startPos))col++;
            lastColHeight[col] = heightChange;
            $872ff7d4ea32e9fa$var$events.push({
                startPos: startPos,
                endPos: endPos,
                height: height,
                col: col,
                period: period
            });
        }
        containerHeight += Math.max(...Object.values(lastColHeight));
        $872ff7d4ea32e9fa$var$calendarElement.style.height = `${containerHeight}px`;
    }
    if (!$872ff7d4ea32e9fa$var$events) return;
    const indicatorDate = new Date(Math.ceil($872ff7d4ea32e9fa$var$startDate.getTime() / 1000 / 60 / 60) * 3600000);
    while(indicatorDate.getTime() < $872ff7d4ea32e9fa$var$endDate.getTime()){
        const time = indicatorDate.toLocaleTimeString('en-US');
        const formatted = `${time.split(':')[0]} ${time.split(' ')[1]}`;
        const top = (indicatorDate.getTime() / 1000 - $872ff7d4ea32e9fa$var$startTime) / 60 * $872ff7d4ea32e9fa$var$pixels_per_minute;
        const span = document.createElement('span');
        span.classList.add('time');
        span.textContent = formatted;
        span.style.top = `${top}px`;
        $872ff7d4ea32e9fa$var$calendarElement.append(span);
        indicatorDate.setTime(indicatorDate.getTime() + 3600000);
    }
    const number_cols = Math.max(...$872ff7d4ea32e9fa$var$events.map((event)=>event.col)) + 1;
    const colwidth = $872ff7d4ea32e9fa$var$calendarElement.clientWidth / number_cols;
    const percent = 1 / number_cols * 100;
    if (data_unprocessed) {
        $872ff7d4ea32e9fa$var$backgroundColor = data_unprocessed.color ? bytes_to_color(data_unprocessed.color) : '#FFFFFF';
        $872ff7d4ea32e9fa$var$textColor = black_or_white($872ff7d4ea32e9fa$var$backgroundColor);
    }
    for (const event of $872ff7d4ea32e9fa$var$events){
        let colspan = 1;
        while(event.col + colspan < number_cols && !$872ff7d4ea32e9fa$var$events.filter((e)=>e.col === event.col + colspan).some((e)=>[
                event.startPos,
                event.endPos
            ].some((p)=>p >= e.startPos && p <= e.endPos)))colspan++;
        let widthOffset = event.col === 0 ? 0 : $872ff7d4ea32e9fa$var$padding * -2;
        if (colwidth * colspan < $872ff7d4ea32e9fa$var$preferred_event_min_width && colspan < number_cols) {
            widthOffset = $872ff7d4ea32e9fa$var$preferred_event_min_width - colwidth * colspan;
            if (widthOffset > colwidth) widthOffset += colwidth - $872ff7d4ea32e9fa$var$min_visible_width;
        }
        const leftOffset = widthOffset * event.col;
        const element = document.createElement('div');
        element.classList.add('event');
        element.style.top = `${event.startPos - 3}px`;
        element.style.height = `${event.height}px`;
        element.style.left = `calc(${percent * event.col}% ${leftOffset < 0 ? '+' : '-'} ${Math.abs(leftOffset)}px)`;
        element.style.width = `calc(${percent * colspan}% ${widthOffset < 0 ? '-' : '+'} ${Math.abs(widthOffset)}px)`;
        element.style.zIndex = number_cols - event.col + 1;
        element.setAttribute('tabindex', '0');
        element.addEventListener('focus', ()=>{
            for (const element_ of document.querySelectorAll('#calendar-table .event.selected'))element_.classList.remove('selected');
            element.classList.add('selected');
        });
        const childElement = document.createElement('div');
        childElement.classList.add('event-child');
        childElement.style.backgroundColor = $872ff7d4ea32e9fa$var$backgroundColor;
        childElement.style.color = $872ff7d4ea32e9fa$var$textColor;
        const nameElement = document.createElement('span');
        nameElement.classList.add('event-name');
        nameElement.innerHTML = period_html(event.period);
        childElement.append(nameElement);
        const timeElement = document.createElement('span');
        timeElement.classList.add('event-time');
        timeElement.innerHTML = `${human_time(event.period.start)} - ${human_time(event.period.end)} (${human_time_left(event.period.end, event.period.start, true)})`;
        childElement.append(timeElement);
        element.append(childElement);
        $872ff7d4ea32e9fa$var$calendarElement.append(element);
    }
}
window.addEventListener('resize', ()=>$872ff7d4ea32e9fa$var$place_boxes());
setInterval($872ff7d4ea32e9fa$var$updateNowBar, 1000);
function $872ff7d4ea32e9fa$var$updateNowBar() {
    const now = current_date().getTime() / 1000;
    if ($872ff7d4ea32e9fa$var$nowBarElement && $872ff7d4ea32e9fa$var$showNowBar && $872ff7d4ea32e9fa$var$startTime && $872ff7d4ea32e9fa$var$endTime && now >= $872ff7d4ea32e9fa$var$startTime && now <= $872ff7d4ea32e9fa$var$endTime) {
        $872ff7d4ea32e9fa$var$nowBarElement.style.top = `${(now - $872ff7d4ea32e9fa$var$startTime) / 60 * $872ff7d4ea32e9fa$var$pixels_per_minute + 10}px`;
        $872ff7d4ea32e9fa$var$nowBarElement.style.display = 'block';
    } else $872ff7d4ea32e9fa$var$nowBarElement.style.display = 'none';
}
$872ff7d4ea32e9fa$var$updateNowBar();
Object.assign(window, {
    place_boxes: $872ff7d4ea32e9fa$var$place_boxes
});


//# sourceMappingURL=schedule.0eba231c.js.map
